import { render, staticRenderFns } from "./RegisterSelectField.vue?vue&type=template&id=531f8319&scoped=true"
import script from "./RegisterSelectField.vue?vue&type=script&lang=js"
export * from "./RegisterSelectField.vue?vue&type=script&lang=js"
import style0 from "./RegisterSelectField.vue?vue&type=style&index=0&id=531f8319&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531f8319",
  null
  
)

export default component.exports